import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Shipper-facing placeholder subscriber for `direct_bid_received`.
 * Toast + chime are owned by useGlobalNotificationAlerts.
 */
export function useDirectBidAlerts(userId: string | null | undefined, enabled: boolean) {
  useEffect(() => {
    if (!userId || !enabled) return;
    const channel = supabase.channel(`direct-bid-alerts-${userId}`).subscribe();
    return () => { supabase.removeChannel(channel); };
  }, [userId, enabled]);
}
